export { PrivateRoute } from './PrivateRoute'
export { PublicRoute } from './PublicRoute'



// WEBPACK FOOTER //
// ./src/components/Routes/index.js